import Nav from './Nav';

export default function Header() {
    return (
        <header className="main-header">
            {/* <div className="text-white d-flex align-items-center justify-content-center font-size-14" style={{backgroundColor: "#E95098", height: "30px"}}>店家訂貨系統 Ordering system</div> */}
            <Nav />
        </header>
    )
}